export const config = {
  id: 'telesalesNoPayment',
  path: '/telesales-no-payment',
  show: () => true,
};
